import React,{useEffect} from 'react';
import { useDispatch,useSelector } from 'react-redux'
import PlanEditor from "./Components/PlanEditor";
import Control from "./Components/Controll";
import ThreeScene from "./Components/ThreeScene";
import Preloader from "./Components/Preloader";
import OrderMenu from "./Components/OrderMenu";
import {actionsState as projectState} from "./Redux/project";
import WallInfo from "./Components/WallInfo";
import ShowHelp from "./Components/ShowHelp";
import {getStrLang} from "./Helpers/functions";

function App() {

    const dispatch = useDispatch();
    const [planeEdit,plan,modules] = useSelector(state=>([
        state.project.planeEdit,
        state.project.plan,
        // state.modules.modules
    ]));
    const modal = useSelector(store=>store.project.modal);

    const setMaterialsModal = ()=>{
        dispatch(projectState.setModal('materials'));
    }

    const setModulesModal = ()=>{
        dispatch(projectState.setModal('modules'));
    }

    const setProjectsModal = ()=>{
        dispatch(projectState.setModal('projects'));
    }

    const setSettingsModal = ()=>{
        dispatch(projectState.setModal('settings'));
    }

    const setShowHelpModal = ()=>{
        dispatch(projectState.setModal('showHelp'));
    }

    useEffect(()=>{
        dispatch({type:'getData'})
    },[]);

    return (
    <div className="App">
        <div>
            {planeEdit===false && <ThreeScene plan={plan}/>}
            {planeEdit===true && <PlanEditor plan={plan} modules={modules}/>}
        </div>
        <Control/>
        <div className="conf-header">
            <div className="project-menu">
                {planeEdit === true && <div>
                    <a href="#" onClick={()=>{setProjectsModal()}}>{ getStrLang('c3d_wFSZI') }</a>|
                    <a href="#" onClick={()=>{setModulesModal()}}>{ getStrLang('c3d_ondsO') }</a>|
                    <a href="#" onClick={()=>{setMaterialsModal()}}>{ getStrLang('c3d_PpxmN') }</a>
                </div>}
            </div>
            <div className="top-menu">
                {/*<a href="#" onClick={()=>{setSettingsModal()}}>{ getStrLang('c3d_JNjwG') }</a>|*/}
                <a href="#" onClick={()=>{setShowHelpModal()}}>{ getStrLang('c3d_CNEUl') }</a>
                <a href="/" className="top-menu-back">{ getStrLang('c3d_1u6Et') }</a>
            </div>
        </div>
        {modal === 'showHelp' && <ShowHelp />}
        <Preloader/>
    </div>
    );
}

export default App;
